import clsx from 'clsx'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import { notificationIndicator } from './NotificationIndicator.css'

interface NotificationIndicatorProps {
  className?: string
  tooltip?: string
}

export const NotificationIndicator = ({
  className,
  tooltip
}: NotificationIndicatorProps) => {
  const indicator = <div className={clsx(notificationIndicator, className)} />

  if (tooltip) {
    return (
      <Tooltip text={tooltip} asChild>
        {indicator}
      </Tooltip>
    )
  }

  return indicator
}
